<script setup>
import { onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import routers from "@/hooks/routers";
import { useStore } from "vuex";
import md5 from "md5";
import { getPartnerSetting, super8 } from "@/api/partner";
import { Dialog, Toast } from "vant";
import { toJson } from "@/utils";

import { NavBar } from "vant";

let orderInfo = reactive({});
let mobile = ref(""); //手机号码
let gift = ref(false);
let isgift = ref(false);

//路由跳转
const { linkTo, goBack, linkTo_H5 } = routers();
const route = useRoute();
const store = useStore();
const titleStatus = store.state.titleStatus;

let welfare_pic = ref("");

// 页面配置
let pageConfig = reactive({ data: {} });
/**
 * @description: 获取页面配置
 * @param {*}
 * @return {*}
 */
async function getPageConfig() {
  let sign = md5(
    `action=setting&appkey=${store.state.appkey}&item_key=yuyueSucceed&partner_id=${store.state.partnerId}${store.state.secret}`
  );

  let params = {
    appkey: store.state.appkey,
    item_key: "yuyueSucceed",
    partner_id: store.state.partnerId,
    sign,
  };
  let resutl = await getPartnerSetting(params);
  console.log(resutl);
  if (resutl.status === 200 && resutl.data?.isSucess) {
    resutl.data.data.item_value = JSON.parse(resutl.data.data.item_value);
    pageConfig.data = resutl.data.data.item_value;
  }
}

// 速8手机号上报
/**
 * @description:
 * @param {*}
 * @return {*}
 */
async function postmobile() {
  let params = {
    mobile: mobile.value,
    id: orderInfo.id,
  };
  let resutl = await super8(params);
  console.log(resutl);
  if (resutl.status === 200 && resutl.data?.isSucess) {
    // Notify({ type: "success", message: "手机号已提交！" });
    Toast.success("提交成功！");
    isgift.value = true;
    gifthide();
  } else {
    Dialog.alert({
      title: "提示",
      message: resutl.data.message,
      theme: "round-button",
    }).then(() => {});
  }
}

/**
 * @description: 跳转检查
 * @param {*}
 * @return {*}
 */
function linkCheck() {
  const data = store.state.partnerConfig?.basic;
  if (data.welfare_type) {
    if (data.welfare_type === "h5") {
      linkTo_H5(data.welfare_content);
    } else if (data.welfare_type === "支付宝小程序") {
      let flag =
        /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
          data.welfare_content
        );
      flag
        ? my.switchTab({ url: data.welfare_content })
        : my.navigateTo({ url: data.welfare_content });
    } else if (data.welfare_type === "微信小程序") {
      let flag =
        /\/pages\/index\/index|\/pages\/yuyue\/yuyue|\/pages\/qiandao\/qiandao|\/pages\/quanzi\/quanzi|\/pages\/jilu\/jilu|\/pages\/my\/my/.test(
          data.welfare_content
        );
      flag
        ? wx.miniProgram.switchTab({ url: data.welfare_content })
        : wx.miniProgram.navigateTo({ url: data.welfare_content });
    } else if (data.welfare_type === "第三方小程序") {
      let obj = toJson(data.welfare_content);
      wx.miniProgram.switchTab({
        url: "../index/index",
      });
      wx.miniProgram.postMessage({
        data: {
          type: "mini",
          appid: obj.appid,
          path: obj.page,
          query: "",
        },
      });
    } else if (data.welfare_type === "自定义") {
      Dialog.alert({
        message: "暂无设置自定义跳转",
        theme: "",
        confirmButtonColor: "#101010",
      });
    }
  } else {
    Dialog.alert({
      message: "暂无设置跳转",
      theme: "",
      confirmButtonColor: "#101010",
    });
  }
}

// 福利弹窗
function giftshow() {
  gift.value = true;
}
function gifthide() {
  gift.value = false;
}

onMounted(() => {
  // 订单参数
  if (Object.entries(route.query).length) {
    orderInfo.name = route.query.name;
    orderInfo.mobile = route.query.mobile;
    orderInfo.date = route.query.date;
    orderInfo.week = route.query.week;
    orderInfo.brandtime = route.query.brandtime;
    orderInfo.brandendtime = route.query.brandendtime;
    orderInfo.province = route.query.province;
    orderInfo.city = route.query.city;
    orderInfo.district = route.query.district;
    orderInfo.address = route.query.address;
    orderInfo.id = route.query.id;
  }
  getPageConfig();
  // 获取预约成功福利跳转图片
  if (store.state.partnerConfig?.basic.welfare == 0) {
    let data = JSON.parse(store.state.partnerConfig.basic.welfare_pic);
    if (data) {
      welfare_pic.value = data.response.data.url;
    }
  }
});
</script>

<template>
  <!-- 主体容器 -->
  <div class="main">
    <div class="wrap">
      <NavBar
        v-if="titleStatus"
        title="预约成功"
        left-arrow
        fixed
        placeholder
        @click-left="goBack"
        :border="false"
      />
      <header>
        <div class="iconfont icon-gou-copy succeedLogo"></div>
        <div class="succeedText">订单提交成功！</div>
        <div class="tips">请留意接收快递员在上门当天的短信联系</div>
        <div class="btns">
          <div class="btn" @click="linkTo('/')">首页</div>
          <div class="btn order" @click="linkTo('/record')">订单记录</div>
        </div>
      </header>
      <section>
        <div class="orderInfo">
          <div class="title">订单信息（请您核对）</div>
          <div class="infos">
            <div>
              <span>上门地点：</span>
              {{ orderInfo.province }}{{ orderInfo.city }}{{ orderInfo.district
              }}{{ orderInfo.address }}
            </div>
            <div>
              <span>上门时间：</span>
              {{ orderInfo.date }} {{ orderInfo.week }} {{ orderInfo.brandtime
              }}{{ orderInfo.brandendtime ? "-" + orderInfo.brandendtime : "" }}
            </div>
            <div>
              <span>用户信息：</span>
              {{ orderInfo.name }} {{ orderInfo.mobile }}
            </div>
          </div>
        </div>
        <div class="welfare">
          <div class="title">订单奖励</div>
          <div class="adO" @click="giftshow()">
            <img :src="welfare_pic" alt />
          </div>
        </div>
      </section>
    </div>
    <div class="bg">
      <img
        class="bg_img"
        :src="pageConfig.data?.succeedPage?.bgImg[0]?.response?.data?.url"
        alt
      />
    </div>
    <div class="finish" @click="linkTo('/')">完成</div>

    <!-- 奖励弹窗 -->
    <div class="mask" v-if="gift"></div>
    <div class="giftbox" v-if="gift">
      <div class="giftx" @click="gifthide()">
        <span class="iconfont icon-guanbi"></span>
      </div>

      <!-- <div class="gifttitle">福利规则</div> -->
      <div class="giftmain">
        <div class="giftfrom" v-if="!isgift">
          <div class="giftf1">
            <img
              src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/sbg.png"
              alt=""
            />
          </div>
          <!-- <div class="giftf1">领取您的专属会员卡</div>
          <div class="giftf2">绑定速8会员手机号码</div> -->
          <div class="giftf3">
            <input type="number" placeholder="手机号码" v-model="mobile" />
          </div>
          <div class="giftf4" @click="postmobile()">确定</div>
        </div>
        <div class="giftfrom" v-else>
          <div class="giftf1">您已成功填写手机号</div>
          <div class="giftf4" @click="gifthide()">确定</div>
        </div>

        <div class="gifttxt">
          <div class="giftp">
            1.速8酒店体验卡可在速8自有渠道预订并享受对应折扣权益和早餐权益。
          </div>
          <div class="giftp">
            2.本次活动赠送的会员体验卡将在衣物回收成功后两个工作日内发放。请在速8酒店APP/小程序中查看。
          </div>
          <div class="giftp">
            3.本次活动赠送的实物奖品将在快递上门确认回收重量后，快递至您预约上门的地址。
          </div>
          <div class="giftp">4.本次活动解释权在法律范围内归速8酒店所有。</div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>

<style lang="scss" scoped>
// 组件样式
:deep(.van-nav-bar) {
  background: #fff3d3;
}
// 组件样式 End
.main {
  min-height: 100vh;
  background: var(--themeBgColor);
  position: relative;
  z-index: 1;
  .wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2;
  }
  .bg {
    position: absolute;
    bottom: 0.35rem;
    width: 100%;
    text-align: center;
    left: 0;
    z-index: 1;
    img {
      width: 100%;
      height: auto;
    }
  }

  header {
    text-align: center;
    font-size: 0.14rem;
    padding: 0.2rem 0 0;
    .succeedLogo {
      font-size: 0.7rem;
      color: var(--themeColor);
    }
    .succeedText {
      color: var(--themeColor);
      margin: 0.1rem 0;
      font-weight: bold;
    }
    .tips {
      font-size: 0.13rem;
      margin: 0 0 0.1rem;
    }
    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.6rem;
      .btn {
        width: calc(50% - 0.22rem);
        text-align: center;
        line-height: 0.3rem;
        border: 1px solid var(--themeColor);
        color: var(--themeColor);
        border-radius: 0.05rem;
        &.order {
          background: var(--themeColor);
          color: #fff;
        }
      }
    }
  }
  section {
    .orderInfo {
      padding: 0.2rem;
      font-size: 0.12rem;
      .title {
        font-size: 0.14rem;
        font-weight: bold;
        margin: 0 0 0.1rem;
      }
      .infos {
        > div {
          margin: 0 0 0.1rem;
          span {
            color: #6f6e6e;
            margin: 0 0.1rem 0 0;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .welfare {
      padding: 0 0.2rem 0.2rem 0.2rem;
      .title {
        font-size: 0.14rem;
        font-weight: bold;
        margin: 0 0 0.1rem;
      }
      .adO {
        margin: 0 0 0.1rem;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .finish {
    position: fixed;
    left: 0.1rem;
    bottom: 0.1rem;
    z-index: 9;
    width: calc(100% - 0.2rem);
    text-align: center;
    line-height: 0.5rem;
    color: #fff;
    border-radius: 0.2rem;
    background: var(--themeColor);
    letter-spacing: 0.1rem;
  }

  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }
  .giftbox {
    width: 95%;
    position: fixed;
    top: 10vh;
    left: 2.5%;
    box-sizing: border-box;
    z-index: 9999;
    .giftx {
      position: absolute;
      right: 15px;
      top: -10px;
      .iconfont {
        color: #fff;
        font-size: 30px;
      }
    }
    .gifttitle {
      font-size: 18px;
      font-weight: bold;
      color: #31cd89;
      text-align: center;
      margin-bottom: 10px;
    }
    .giftmain {
      .gifttxt {
        width: 78%;
        margin: 30px auto 0;
        .giftp {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 25px;
        }
      }
      .giftfrom {
        padding: 20px 0 0;
        text-align: center;
        .giftf1 {
          font-size: 16px;
          img {
            width: 100%;
          }
        }
        .giftf2 {
          font-size: 12px;
          color: #666666;
          margin-bottom: 15px;
        }
        .giftf3 {
          position: relative;
          top: -55px;
          width: 78%;
          margin: 0 auto;
          input {
            border: none;
            outline: none;
            border: 1px solid #d9d9d9;
            border-radius: 50px;
            height: 45px;
            text-align: center;
            width: 100%;
            font-weight: bold;
          }
        }
        .giftf4 {
          background: #31cd89;
          color: #fff;
          font-size: 18px;
          width: 50%;
          margin: 0 auto;
          height: 50px;
          line-height: 50px;
          border-radius: 50px;
          position: relative;
          top: -20px;
        }
      }
    }
  }
}
</style>
